<template>
    <ModalBase
        name="crear-codigos"
        :title="title"
        @close="close"
        :width="520"
    >
        <ValidationObserver tag="form" ref="observer" class="tw:space-y-4" @submit.prevent="onSubmit">
            <BaseInputNumber
                v-model="cantidad_codigos"
                name="cantidad_codigos"
                label="Cantidad de códigos"
                :min="1"
                :step="1"
                rules="required|min_value:1"
            />

            <BaseInputNumber
                v-model="usos"
                name="usos"
                label="Número de usos por código"
                :min="1"
                :step="1"
                rules="required|min_value:1"
            />
        </ValidationObserver>

        <template #footer>
            <div class="tw:flex tw:justify-end tw:gap-2">
                <Button variant="ghost" @click="close" :disabled="loading">Cancelar</Button>
                <Button variant="primary" type="button" :loading="loading" @click="onSubmit">
                    Guardar
                </Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, getCurrentInstance } from 'vue';
    import store from '@/store';
    import { config } from '@/config.js';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue';
    import Button from '@/modules/admin/ui/Button.vue';
    import { useToast } from '@/composables/common/useToast';

    const props = defineProps({
        title: {
            type: String,
            default: 'Crear códigos de invitación para la categoría'
        },
        listaId: {
            type: [String, Number],
            required: true
        },
        categoriaId: {
            type: [String, Number],
            required: true
        }
    });

    const emit = defineEmits(['close', 'creado']);

    const instance = getCurrentInstance();
    const toast = useToast();
    const observer = ref(null);
    const cantidad_codigos = ref(20);
    const usos = ref(50);
    const loading = ref(false);

    function close() {
        instance.proxy.$modal.hide('crear-codigos');
        emit('close');
    }

    async function onSubmit() {
        const isValid = await observer.value.validate();
        if (!isValid) return;

        loading.value = true;
        try {
            const teatro = store.getters.getTeatro;
            const teatroId = teatro?.id || 0;

            await store.dispatch(
                config.getVuexAlias('back.bases.categorias.codigos_invitacion.crear'),
                {
                    lista_id: props.listaId,
                    teatro_id: teatroId,
                    categoria_id: props.categoriaId,
                    cantidad_codigos: cantidad_codigos.value,
                    usos: usos.value,
                    filters: {}
                }
            );
            toast.success('Códigos creados correctamente.');
            emit('creado');
            close();
        } catch (error) {
            console.error('Error creating codigos invitacion:', error);
            toast.error(error.response?.data?.message || 'Error al crear los códigos');
        } finally {
            loading.value = false;
        }
    }
</script>
